/**
 * Languages API
 * Fetches available application languages for the kiosk
 */

import { TokenManager } from '@/core/auth/token-manager';
import { ApiErrorMiddleware } from '@/core/api-error-middleware';
import { ApplicationLanguagesResponse } from '../types/languages-types';

export class LanguagesApi {
  constructor(
    private readonly baseUrl: string,
    private readonly tokenManager: TokenManager
  ) {}

  
  async getApplicationLanguages(): Promise<ApplicationLanguagesResponse> {
    const endpoint = `${this.baseUrl}/translations/application-languages/3`;

    console.log('[LanguagesApi] Fetching languages from:', endpoint);

    try {
      const headers = await this.tokenManager.getAuthHeaders();
      const response = await ApiErrorMiddleware.fetchWithErrorHandling(
        endpoint,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...headers
          }
        },
        'Languages API',
        endpoint
      );

      const data = await response.json() as ApplicationLanguagesResponse;
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to fetch languages';
      console.error('[LanguagesApi] Fetch error:', message);
      throw error;
    }
  }
}
